<template>
  <div class="sign_form" @keydown="keydown">
    <header><span class="header_sign_text">注册</span><span>已有账号?<span class="direct" @click="$FN.visibleLogin(1)">直接登录</span><a-icon type="close" @click.stop="$FN.visibleLogin()" /></span></header>
    <AntForm :data="form" :rows="1" ref="AntForm" />
    <a-button block type="primary" class="ant_btn_login" :loading="signLoading" @click="sign">立即注册</a-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      loading: false,
      signLoading: false,
      emailCodeLoading: false,
      num: 0,
      timer: null,
      userNameFlag: false,
      emailFlag: false,
      phoneFlag: false,
      passwordFlag: false,
      time: null
    }
  },
  created() {
    this.setForm();
  },
  beforeDestroy() {
    this.clearTime();
  },
  methods: {
    clearTime() {
      clearTimeout(this.time);
      this.time = null;
    },
    // 用户敲击回车
    keydown(e) {
      // 与表单change发生冲突，将任务放到宏任务中
      if (e.keyCode === 13) this.time = setTimeout(this.sign, 250);
    },
    sign() {
      this.clearTime();
      this.$refs.AntForm.validateFields((err, { confirmpassword, mailCode, username, ...rest }) => {
        if (!err) {
          let { userNameFlag = false, emailFlag = false, phoneFlag, passwordFlag = false } = this;
          if (!userNameFlag) return this.$message.error("账号已被注册,请更换!");
          if (!emailFlag) return this.$message.error("邮箱已被注册,请更换!");
          if (!phoneFlag) return this.$message.error("手机号已被注册,请更换!");
          if (!passwordFlag) return this.$message.error("两次密码不一致!");
          this.signLoading = true;
          let form = { username, nickName: username, ...rest };
          this.$FN.post(`open/api/users/register/PES/${mailCode}`, form).then(res => {
            this.signLoading = false;
            if (res) {
              let { code = 500, msg = "设备网络错误" } = res;
              if (code === 100) {
                this.$message.success(msg);
                this.$FN.visibleLogin(1);
              } else {
                this.$message.error(msg);
              }
            }
          })
        }
      });
    },
    getEmailCode() {
      this.$refs.AntForm.form.validateFields(['email'], (err, form) => {
        if (!err) {
          this.emailCodeLoading = true;
          let { email = null } = form;
          this.$FN.get("open/api/users/send/email/code", { email }).then(res => {
            this.emailCodeLoading = false;
            if (res) {
              let { code = 500, msg = "" } = res;
              if (code === 100) {
                this.emailFlag = true;
                this.setTimer();
                this.$message.success(msg);
              } else {
                this.emailFlag = false;
                this.$message.error(msg);
              }
            };
          })
        }
      });
    },
    setTimer() {
      this.num = 120;
      this.timer = setInterval(() => {
        this.num -= 1;
        if (!this.num) {
          clearInterval(this.timer);
          this.timer = null;
        };
      }, 1000);
    },
    mailboxCheck(key = null) {
      // let { username = null, email = null, password = null, confirmpassword = null } = this.$refs.FORM.getForm();
      this.$refs.AntForm.form.validateFields(['email', 'username', 'phone', 'password', 'confirmpassword'], (err, { email, username, phone, password, confirmpassword }) => {
        // 查看账号与邮箱手机号是否已经注册
        (key === 'userName') && username && this.inspectUserName(username);
        (key === 'email') && email && this.inspectEmail(email);
        (key === 'phone') && email && this.inspectPhone(phone);

        if ((password && confirmpassword) && password !== confirmpassword) {
          this.passwordFlag = false;
          return this.$message.error("两次密码不一致!");
        } else {
          this.passwordFlag = true;
        }
      });
    },
    inspectUserName(userName) {
      let config = { contentType: "0" };
      // api/user_service/reg/checkRegistUserName 原接口
      this.$FN.post("/open/api/users/checkUsernameExist", { userName }, config).then(res => {
        if (res) {
          let { code = 500, msg = "设备网络错误" } = res;
          if (code === 100) {
            this.userNameFlag = true;
            this.$message.success("用户名可用!")
          } else {
            this.userNameFlag = false;
            this.$message.error(msg);
          }
        }
      })
    },
    inspectEmail(email) {
      let config = { contentType: "0" };
      // api/user_service/reg/checkRegistEmail 原接口
      this.$FN.post("/open/api/users/checkEmailExist", { email }, config).then(res => {
        if (res) {
          let { code = 500, msg = "设备网络错误" } = res;
          if (code === 100) {
            this.emailFlag = true;
            this.$message.success("邮箱可用!")
          } else {
            this.emailFlag = false;
            this.$message.error(msg);
          }
        }
      })
    },
    inspectPhone(phone) {
      let config = { contentType: "0" };
      this.$FN.post("/open/api/users/checkPhoneExist", { phone }, config).then(res => {
        if (res) {
          let { code = 500, msg = "设备网络错误" } = res;
          if (code === 100) {
            this.phoneFlag = true;
            this.$message.success("手机号可用!")
          } else {
            this.phoneFlag = false;
            this.$message.error(msg);
          }
        }
      })
    },
    setForm() {
      this.form = {
        username: {
          label: "账号",
          placeholder: "输入账号",
          prefixIcon: "iconfont icon-pes_icon_line_yonghuming",
          clearable: true,
          on: { 'blur': () => this.mailboxCheck("userName") },
          rules: [{ required: true, message: "请输入账号", trigger: 'blur' }, this.$RULES.rules.username[1], this.$RULES.noSpace],
        },
        email: {
          label: "邮箱",
          placeholder: "输入邮箱",
          prefixIcon: "iconfont icon-pes_icon_line_youxiang",
          clearable: true,
          on: { 'blur': () => this.mailboxCheck("email") },
          rules: [{ required: true, message: "请输入邮箱", trigger: 'blur' }, this.$RULES.email],
        },
        phone: {
          label: "手机号",
          placeholder: "输入手机号",
          prefixIcon: "iconfont icon-pes_icon_line_shouji",
          clearable: true,
          on: { 'blur': () => this.mailboxCheck("phone") },
          rules: [{ required: true, message: "请输入手机号", trigger: 'blur' }, this.$RULES.phone],
        },
        password: {
          label: "密码",
          type: "password",
          placeholder: "输入密码",
          prefixIcon: "iconfont icon-pes_icon_line_mima",
          showPassword: true,
          on: { 'blur': this.mailboxCheck },
          rules: [{ required: true, message: "请输入密码", trigger: 'blur' }, { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' }, this.$RULES.weakPassword],
        },
        confirmpassword: {
          label: "确认密码",
          type: "password",
          placeholder: "输入确认密码",
          prefixIcon: "iconfont icon-pes_icon_line_mima",
          showPassword: true,
          on: { 'blur': this.mailboxCheck },
          rules: [{ required: true, message: "请输入确认密码", trigger: 'blur' }, { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' }, this.$RULES.weakPassword],
        },
        mailCode: {
          label: "邮箱验证码",
          value: "",
          rules: [{ required: true, message: "请输入验证码", trigger: 'blur' }],
          render: a => {
            return (
              <div class="render_code">
                <div class="left_input">
                  <a-input v-decorator={['mailCode', { rules: [{ required: true, message: "请输入验证码", trigger: 'blur' }] }]} placeholder="输入验证码" />
                </div>
                <div class="right_btn">
                  <a-button type="primary" style={{ opacity: this.mailCodeOpacity }} loading={this.emailCodeLoading} disabled={!!this.timer} onClick={this.getEmailCode}>{this.timer ? `${this.num}秒后获取邮箱验证码` : '发送验证码到邮箱'}</a-button>
                </div>
              </div>
            )
          }
        }
      };
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>